export const projects = [
    {
        title : "SocioLiz",
        tags : ["React", "Node", "Express", "MongoDB", "Socket"],
        image : "projects/socioliz.jpeg",
        url : "https://github.com/aayushsrivastava9760/SocioLiz"
    },
    {
        title : "Portfolio Prev.",
        tags : ["React", "Tailwind", "JS"],
        image : "projects/portfolio.jpeg",
        url : "https://aayush-srivastava.netlify.app/"
    },
    {
        title : "Jobs API",
        tags : ["Node", "Express", "Mongoose", "Swagger"],
        image : "projects/jobs-api.jpeg",
        url : "https://github.com/aayushsrivastava9760/Jobs-api"
    },
    {
        title : "Todo App 2.0",
        tags : ["Next", "CSS", "JS"],
        image : "projects/todo2.jpeg",
        url : "https://todo-app-by-aayush.vercel.app/login"
    },
    {
        title : "Tic Tac Toe",
        tags : ["HTML", "JS", "CSS"],
        image : "projects/tic-tac-toe.jpeg",
        url : "https://aayushsrivastava9760.github.io/TicTacToebyAayush.github.io/"
    },
    {
        title : "Menu",
        tags : ["React", "CSS", "JS"],
        image : "projects/menu.jpeg",
        url : "https://menu-app-by-aayush.netlify.app/"
    },
    {
        title : "Ninja Website",
        tags : ["Next", "CSS", "JS"],
        image : "projects/ninja.jpeg",
        url : "https://ninja-list-by-aayush.vercel.app/"
    },
    {
        title : "Birthday Reminder",
        tags : ["Next", "Node", "Express"],
        image : "projects/bday.jpeg",
        url : "https://birthday-reminder-app-by-aayush.netlify.app/"
    },
    {
        title : "Tours",
        tags : ["React", "CSS", "JS"],
        image : "projects/tour.jpeg",
        url : "https://tours-app-by-aayush.netlify.app/"
    },
    {
        title : "Reviews",
        tags : ["React", "CSS", "JS"],
        image : "projects/reviews.jpeg",
        url : "https://reviews-by-aayush.netlify.app/"
    },
    {
        title : "FAQ App",
        tags : ["React", "CSS", "JS"],
        image : "projects/faq.jpeg",
        url : "https://accordian-by-aayush.netlify.app/"
    },
    {
        title : "Todo App",
        tags : ["HTML", "CSS", "JS"],
        image : "projects/todo.jpeg",
        url : "https://todo-app-by-aayush.netlify.app/login/"
    },
]